export const enGb = {
  active: "Active",
  aisStatus: "AIS Status",
  aisVisible: "AIS Visible",
  bankGroup: "Bank Group",
  configuration: "Configuration",
  configurationState: "Configuration state",
  configuredCurrencies: "Configured Currencies",
  country: "Country",
  inactive: "Inactive",
  institution: "Bank",
  no: "No",
  pisStatus: "PIS Status",
  pisVisible: "PIS Visible",
  reset: "Reset",
  selectCustomer: "Select a customer",
  sepaInstant: "SEPA Instant",
  state: "State",
  stateCustom: "custom",
  stateDefault: "default",
  supportsSepaInstant: "Supports SEPA Instant",
  toViewBankListSelectCustomer:
    "To view the bank list, please select a customer.",
  yes: "Yes",
} as const;
